type Props = {
  alt: string;
  src: string;
};

const AffiliateLogo = ({ src, alt }: Props) => {
  return (
    <img
      src={src}
      alt={alt}
      className="rounded bg-white object-cover text-black"
    />
  );
};

export default AffiliateLogo;
